<template>
  <div>
    <div id="map"></div>

    <!-- Get Shops modal -->
    <div id="mydivShopsShow">
      <div id="mydivShopsShowheader" class="text-white">
        เลือกประเภทร้านค้า/บริการ
        <i
          :class="iconReportShops"
          @click="adjustWindowShops"
          :style="styleIconShops"
        ></i
        ><i class="pi pi-times pointer" @click="clearDataShops()"></i>
      </div>
      <div
        class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2"
        v-if="displayShops == true"
      >
        <div class="p-grid p-col" style="margin-bottom: -15px">
          <div class="p-col">
            <Dropdown
              v-model="shopsEvent_ShopsType"
              :options="shops_Type_Option"
              optionLabel="shop_typ_nme"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="shops_Type_Option">
                <div v-if="shops_Type_Option.value">
                  <div>{{ shops_Type_Option.value.shop_typ_nme }}</div>
                </div>
                <span v-else>
                  {{ shops_Type_Option.placeholder }}
                </span>
              </template>
              <template #option="shops_Type_Option">
                <div>{{ shops_Type_Option.option.shop_typ_nme }}</div>
              </template>
            </Dropdown>
          </div>
        </div>

        <div class="p-grid p-col" style="margin-bottom: -15px">
          <div class="p-col-7"></div>
          <div class="p-col-5">
            <Button
              @click="confirmShopsShow()"
              label="แสดงข้อมูล"
              class="p-button-success p-mb-2"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Get Shops modal -->
    <div id="mydivUsersShow">
      <div id="mydivUsersShowheader" class="text-white">
        เลือกสถานะผู้ใช้งานทั่วไป
        <i
          :class="iconReportUsers"
          @click="adjustWindowUsers"
          :style="styleIconUsers"
        ></i
        ><i class="pi pi-times pointer" @click="clearDataUsers()"></i>
      </div>
      <div
        class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2"
        v-if="displayUsers == true"
      >
        <div class="p-grid p-col" style="margin-bottom: -15px">
          <div class="p-col">
            <Dropdown
              v-model="usersEvent_UsersType"
              :options="users_Type_Option"
              optionLabel="user_typ_nme"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="users_Type_Option">
                <div v-if="users_Type_Option.value">
                  <div>{{ users_Type_Option.value.user_typ_nme }}</div>
                </div>
                <span v-else>
                  {{ users_Type_Option.placeholder }}
                </span>
              </template>
              <template #option="users_Type_Option">
                <div>{{ users_Type_Option.option.user_typ_nme }}</div>
              </template>
            </Dropdown>
          </div>
        </div>

        <div class="p-grid p-col" style="margin-bottom: -15px">
          <div class="p-col-7"></div>
          <div class="p-col-5">
            <Button
              @click="confirmUsersShow()"
              label="แสดงข้อมูล"
              class="p-button-success p-mb-2"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- User Information modal (2) -->
    <Dialog
      :modal="true"
      :visible.sync="systemUserModal"
      :style="{ width: '660px' }"
      :header="headerUser"
    >
      <div v-if="dataOnClickUsersMarker != null">
        <div class="confirmation-content">
          <label>{{ $t("systemUser_modal_subtitle") }}</label>
          <div class="p-fluid p-mt-3">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-3">
                <img
                  class="edituserimg"
                  :src="httpimg(dataOnClickUsersMarker.memb_img_main)"
                  @error="replaceByDefault"
                  style="vertical-align: middle"
                />
              </div>
              <div class="p-field p-col-9" />
            </div>

            <div class="p-formgrid p-grid p-mt-3" style="margin-left: 150px">
              <div class="p-field p-col-6">
                <label for="igeneral_dataName"
                  >{{ $t("imp_firstname") }}
                </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickUsersMarker.memb_nme"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickUsersMarker.memb_nme,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName && !dataOnClickUsersMarker.memb_nme
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-6">
                <label for="igeneral_dataName">{{ $t("imp_lastname") }} </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickUsersMarker.memb_snme"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickUsersMarker.memb_snme,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName && !dataOnClickUsersMarker.memb_snme
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-5">
              <div class="p-field p-col-3">
                <label for="igeneral_dataName">{{ $t("phone_number") }} </label>

                <InputText
                  :disabled="false"
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickUsersMarker.memb_pnum"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickUsersMarker.memb_pnum,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName && !dataOnClickUsersMarker.memb_pnum
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-9">
                <label for="igeneral_dataName">{{ $t("email") }} </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickUsersMarker.memb_email"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickUsersMarker.memb_email,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickUsersMarker.memb_email
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-4">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_dvdate") }}
                </label>

                <Calendar
                  :disabled="true"
                  dateFormat="dd/MM/yy"
                  :showButtonBar="true"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  yearRange="2000:2050"
                  :locale="th"
                  id="igeneral_dataName"
                  v-model="dataOnClickUsersMarker.memb_dvdate"
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickUsersMarker.memb_dvdate,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickUsersMarker.memb_dvdate
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-4">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_dvtime") }}
                </label>

                <Calendar
                  :disabled="true"
                  :timeOnly="true"
                  hourFormat="24"
                  :showSeconds="true"
                  id="igeneral_dataName"
                  v-model="dataOnClickUsersMarker.memb_dvdate"
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickUsersMarker.memb_dvdate,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickUsersMarker.memb_dvdate
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-4">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_rgdate") }}
                </label>

                <Calendar
                  :disabled="true"
                  dateFormat="dd/MM/yy"
                  :showButtonBar="true"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  yearRange="2000:2050"
                  :locale="th"
                  id="igeneral_dataName"
                  v-model="dataOnClickUsersMarker.memb_rgdate"
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickUsersMarker.memb_rgdate,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickUsersMarker.memb_rgdate
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-4">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_rgtime") }}
                </label>

                <Calendar
                  :disabled="true"
                  :timeOnly="true"
                  hourFormat="24"
                  :showSeconds="true"
                  id="igeneral_dataName"
                  v-model="dataOnClickUsersMarker.memb_rgdate"
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickUsersMarker.memb_rgdate,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickUsersMarker.memb_rgtime
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          :label="$t('closeBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="closeData()"
        />
      </template>
    </Dialog>

    <!-- Shop Information modal (2) -->
    <Dialog
      :modal="true"
      :visible.sync="systemShopModal"
      :style="{ width: '660px' }"
      :header="headerShop"
    >
      <div v-if="dataOnClickShopsMarker != null">
        <div class="confirmation-content">
          <label>{{ $t("systemShop_modal_subtitle") }}</label>
          <div class="p-fluid p-mt-3">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-3">
                <img
                  class="edituserimg"
                  :src="httpimg(dataOnClickShopsMarker.shop_img_main)"
                  @error="replaceByDefault"
                  style="vertical-align: middle"
                />
              </div>
              <div class="p-field p-col-9" />
            </div>

            <div class="p-formgrid p-grid p-mt-3" style="margin-left: 150px">
              <div class="p-field p-col-12">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_shop") }}
                </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.shop_nme"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.shop_nme,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName && !dataOnClickShopsMarker.shop_nme
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-5" style="margin-left: -5px">
              <div class="p-field p-col-12">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_desc") }}
                </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.shop_desc"
                  readonly="true"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.shop_desc,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName && !dataOnClickShopsMarker.shop_desc
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-3">
              <div class="p-field p-col-3">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_shop_status") }}
                </label>

                <InputText
                  :disabled="false"
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.shop_status"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.shop_status,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.shop_status
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-9">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_shop_type") }}
                </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.shop_typ_nme"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.shop_typ_nme,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.shop_typ_nme
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-3">
              <div class="p-field p-col-3">
                <label for="igeneral_dataName">{{ $t("phone_number") }} </label>

                <InputText
                  :disabled="false"
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.shop_contact_pnum"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.shop_contact_pnum,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.shop_contact_pnum
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-9">
                <label for="igeneral_dataName">{{ $t("email") }} </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.shop_email"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.shop_email,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.shop_email
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-3">
              <div class="p-field p-col-7">
                <label for="igeneral_dataName"
                  >{{ $t("igeneral_location") }}
                </label>

                <InputText
                  :disabled="false"
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.shop_address"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.shop_address,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.shop_address
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-5">
                <label for="igeneral_dataName">{{ $t("tambon") }} </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.loc_tam_th"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.loc_tam_th,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.loc_tam_th
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>

            <div class="p-formgrid p-grid p-mt-3">
              <div class="p-field p-col-5">
                <label for="igeneral_dataName">{{ $t("amphur") }} </label>

                <InputText
                  :disabled="false"
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.loc_amp_th"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.loc_amp_th,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.loc_amp_th
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-5">
                <label for="igeneral_dataName">{{ $t("province") }} </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.loc_prov_th"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.loc_prov_th,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.loc_prov_th
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>

              <div class="p-field p-col-2">
                <label for="igeneral_dataName">{{ $t("postcode") }} </label>

                <InputText
                  id="igeneral_dataName"
                  type="text"
                  v-model="dataOnClickShopsMarker.shop_postcode"
                  required="true"
                  readonly="true"
                  autofocus
                  :class="{
                    'p-invalid':
                      error_igeneral_dataName &&
                      !dataOnClickShopsMarker.shop_postcode,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="
                    error_igeneral_dataName &&
                    !dataOnClickShopsMarker.shop_postcode
                  "
                  >{{ $t("igeneral_dataName_validate") }}</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          :label="$t('closeBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="closeData()"
        />
      </template>
    </Dialog>

    <Toast />
  </div>
</template>

<script>
import moment from "moment";
//Map js
import $ from "jquery";
import L from "leaflet";
import { ZoomShowHide } from "../../public/assets/leaflet/dist/leaflet-zoom-show-hide";
import "../../public/assets/leaflet/src/L.Control.Locate";
import "../../public/assets/leaflet/dist/Leaflet.Coordinates-0.1.3.min.js";
import "../../public/assets/leaflet/dist/leaflet-history-src";
import "../../public/assets/leaflet/dist/leaflet-history";
import "../../public/assets/leaflet/src/history";
import "../../public/assets/leaflet/src/leaflet-ruler.js";
import "../../public/assets/leaflet/src/leaflet-measure.js";
import "../../public/assets/leaflet/lib/Control.SimpleMarkers.js";
import "../../public/assets/leaflet/lib/Control.SimpleMarkers.js";
import "../../public/assets/leaflet/dist/leaflet.markercluster-src";

//Css
import "../../public/assets/leaflet/src/leaflet-ruler.css";
import "../../public/assets/leaflet/src/leaflet-measure.css";
import "../../public/assets/leaflet/lib/Control.SimpleMarkers.css";
import "../../public/assets/leaflet/dist/Leaflet.Coordinates-0.1.3.css";
import "../../public/assets/leaflet/dist/L.Control.Locate.min.css";
import "../../public/assets/leaflet/dist/leaflet.zoomhome.css";
import "../../public/assets/leaflet/dist/leaflet-history.css";
import "../../public/assets/leaflet/src/disaster-map-style.css";

export default {
  name: "disaster-map",
  components: {},

  data() {
    return {
      //table
      systemShopsData_table: [],
      systemUsersData_table: [],
      Shopsfilters: {},
      Usersfilters: {},
      headerShop: this.$i18n.t("systemShop_modal_title"),
      headerUser: this.$i18n.t("systemUser_modal_title"),
      display: false,
      displayShops: false,
      displayUsers: false,
      systemUserModal: false,
      systemShopModal: false,
      icon: "",
      iconReportShops: "",
      iconReportUsers: "",
      iconReportUsersDetail: "",
      styleIcon: "",
      styleIconShops: "",
      styleIconUsers: "",
      styleIconReportUsersDetail: "",

      dataOnClickShopsMarker: null,
      imgOnClickShopsMarker: null,

      dataOnClickUsersMarker: null,
      imgOnClickUsersMarker: null,

      event_name: "",
      event_lat: "",
      event_lng: "",
      event_date: "",
      event_time: "",
      shops_Type_Option: [],
      users_Type_Option: [],
      users_Type: [],
      disaster_type_select: null,
      event_location: "",
      event_call_name: "",
      event_call_phone: "",
      url_image: null,
      event_image_name: "",
      error_event_name: false,
      error_disaster_type_select: false,
      error_event_lat: false,
      error_event_lng: false,
      error_event_date: false,
      error_event_time: false,
      error_event_location: false,
      error_event_call_name: false,
      error_event_call_phone: false,
      map: null,
      streets_satellite: null,
      strDeeMap:
        "DeeMap Version 2.20.0 - Copyright © 2018 - 2022 - Powered By Thai Digital Map",
      urlDeeMap: "https://www.deemap.com/DeeMap/gwc/service/wms?",
      deemapLight: null,
      deemapNight: null,
      deemapWorldStreetMap: null,
      wmslayer: null,
      polygon: null,
      baseLayers: {},
      zsh: null,
      parcel: null,
      exten: null,
      zoomIn: null,
      zoomOut: null,
      alert: null,
      noed: null,
      marker1: [],
      // popup: null,
      popup2: null,
      icnoIdentifyLocation: null,
      iconFindLocation: null,
      iconSearch: null,
      options: {},
      measureControl: null,
      marker_controls: null,
      icnoUsersShow: null,
      error_igeneral_dataName: false,
      mapUsersMarkers: [],
      mapUsersMarkersIcon: [],
      mapUsersMarkersCircle: [],
      mapShopsMarkersCircle: [],
      mapShopsMarkers: [],
      mapShopsMarkersIcon: [],
      mapMarkers: [],
      mapMarkersIcon: [],

      idnController3: 0,
      idnControllerShops: 0,
      idnControllerUsers: 0,
      idnController5: 0,
      download_ext: "",
      pv: null,
      ap: null,
      tb: null,
      misgis_fire_station: null,
      misgis_6_division: null,
      layerControl: null,

      //for shops show
      shopsEvent_ShopsType: null,
      //for users shop
      usersEvent_UsersType: null,
    };
  },

  created() {
    this.axios
      .get(`${this.$url_service}/shops/type/all`, {
        body: {},
      })
      .then((response) => {
        response.data[0].data.push({
          id: "styp-99999",
          shop_typ_id: "styp-99999",
          shop_typ_nme: "ทุกประเภทร้านค้า/บริการ",
        });
        this.shops_Type_Option = response.data[0].data;
      });

    this.users_Type.push(
      {
        id: "utyp-99999",
        user_typ_id: "utyp-99999",
        user_typ_nme: "ทุกสถานะ",
      },
      {
        id: "utyp-99998",
        user_typ_id: "utyp-99998",
        user_typ_nme: "สถานะปกติ",
      },
      {
        id: "utyp-99997",
        user_typ_id: "utyp-99997",
        user_typ_nme: "สถานะยกเลิก",
      }
    );

    this.users_Type_Option = this.users_Type;

    this.streets_satellite = L.tileLayer(
      "https://a.tiles.mapbox.com/v4/mapbox.streets-satellite/{z}/{x}/{y}.png?access_token={token}",
      {
        attribution: "Mapbox",
        subdomains: ["a", "b", "c", "d"],
        token:
          "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
      }
    );

    /* Basemap Layers */
    this.deemapLight = L.tileLayer(
      "https://www.deemap.com/DeeMap/gwc/service/tms/1.0.0/DeeMap2_THA_Map_No_POI@EPSG%3A900913@png8/{z}/{x}/{-y}.png8",
      {
        maxZoom: 30,
        attribution: this.strDeeMap,
      }
    );
    this.deemapNigth = L.tileLayer.wms(this.urlDeeMap, {
      minZoom: 0,
      maxZoom: 30,
      layers: "DeeMap2_THA_Map_Night",
      format: "image/png8",
      id: "deemapnigth",
      attribution: this.strDeeMap,
    });

    this.deemapWorldStreetMap = L.esri.basemapLayer("Streets");

    this.wmslayer = L.tileLayer.wms(
      "http://digitalcity.dtc.co.th:8080/DeeMap_Msd01/gwc/service/wms",
      {
        layers: "cite:Pattaya",
        format: "image/png8",
        transparent: true,
      }
    );

    this.polygon = L.tileLayer.wms(
      "http://digitalcity.dtc.co.th:8080/DeeMap_Msd01/wms?",
      {
        layers: "pattaya_200463",
        format: "image/png",
        transparent: true,
      }
    );

    this.zsh = new ZoomShowHide();

    //เรียกใช้งาน Webservice
    //ประกาศตัวแปร var parcel ให้เป็นฟังก์ชั่น L.layerGroup สำหรับสร้าง layer
    this.parcel = L.layerGroup();
    this.exten = L.control({
      position: "bottomright",
    });
    this.zoomIn = L.control({
      position: "bottomright",
    });
    this.zoomOut = L.control({
      position: "bottomright",
    });

    this.alert = L.control({
      position: "topleft",
    });

    this.noed = L.layerGroup();

    this.icnoIdentifyLocation = L.control({
      position: "bottomright",
    });

    this.popup2 = L.popup({
      className: "popupFindLocation",
    });

    //เริ่มต้นปุ่ม search
    this.icnoSearch = L.control({
      position: "bottomright",
    });

    //เริ่มต้นปุ่มxy
    this.iconFindLocation = L.control({
      position: "bottomright",
    });

    this.options = {
      position: "bottomleft", // Leaflet control position option
      title: "Cancel editing, discards all changes",
      //   title: 'test',
      circleMarker: {
        // Leaflet circle marker options for points used in this plugin
        color: "red",
        radius: 2,
      },
      lineStyle: {
        // Leaflet polyline options for lines used in this plugin
        color: "red",
        dashArray: "1,6",
      },
      lengthUnit: {
        // You can use custom length units. Default unit is kilometers.
        //   factor: 0.539956803,
        display: "km", // This is the display value will be shown on the screen. Example: 'meters'
        decimal: 2, // Distance result will be fixed to this value.
        factor: null, // This value will be used to convert from kilometers. Example: 1000 (from kilometers to meters)
        label: "Distance:",
      },
      angleUnit: {
        display: "&deg;", // This is the display value will be shown on the screen. Example: 'Gradian'
        decimal: 2, // Bearing result will be fixed to this value.
        factor: null, // This option is required to customize angle unit. Specify solid angle value for angle unit. Example: 400 (for gradian).
        label: "Bearing:",
      },
    };

    this.measureControl = new L.Control.Measure({
      position: "bottomleft",
      primaryLengthUnit: "kilometers",
      secondaryLengthUnit: "meters",
      primaryAreaUnit: "sqmeters",
      completedColor: "red",
    });

    // Create the marker controls
    this.marker_controls = new L.Control.SimpleMarkers({
      position: "bottomleft",
    });

    //เริ่มต้นปุ่มแสดงข้อมูลผู้ใช้งานทั่วไป
    this.icnoUsersShow = L.control({
      position: "topleft",
    });

    //เริ่มต้นปุ่มแสดงข้อมูลร้านค้าและบริการ
    this.icnoShopsShow = L.control({
      position: "topleft",
    });
  },

  mounted() {
    this.map = L.map("map", {
      center: [13.6750394, 100.6037526],
      zoom: 17,
      maxZoom: 19,
      layers: [this.deemapLight],
    });
    this.zsh.addTo(this.map);

    this.pv = L.tileLayer.wms(
      "https://www.deemap.com/geoserver/gwc/service/wms",
      {
        layers: "Project:province_accident",
        format: "image/png8",
        transparent: true,
      }
    );

    this.ap = L.tileLayer.wms(
      "https://www.deemap.com/geoserver/gwc/service/wms",
      {
        layers: "Project:amphoe_accident",
        format: "image/png8",
        transparent: true,
      }
    );

    this.tb = L.tileLayer.wms(
      "https://www.deemap.com/geoserver/gwc/service/wms",
      {
        layers: "Project:tambon_accident",
        format: "image/png8",
        transparent: true,
      }
    );

    // ! เพิ่มชั้นข้อมูล WMS มี 2 ส่วน  คือ 1.ขอบเขตสถานีดับเพลิงและกู้ภัย และ 2.ขอบเขต 6 กองปฏิบัติการดับเพลิงและกู้ภัย
    // ! 1. ขอบเขตสถานีดับเพลิงและกู้ภัย
    this.misgis_fire_station = L.tileLayer.wms(
      "https://www.deemap.com/geoserver/gwc/service/wms",
      {
        layers: "misgis_fire_station_20211229",
        format: "image/png8",
        transparent: true,
      }
    );
    // ! 2. ขอบเขต 6 กองปฏิบัติการดับเพลิงและกู้ภัย
    this.misgis_6_division = L.tileLayer.wms(
      "https://www.deemap.com/geoserver/gwc/service/wms",
      {
        layers: "misgis_6_division_20211229",
        format: "image/png8",
        transparent: true,
      }
    );

    // Layers Users on Maps
    this.icnoUsersShow.onAdd = () => {
      var Div = L.DomUtil.create("div");
      Div.id = "UsersShow";
      Div.innerHTML = `<div id="buttonMap" data-toggle="tooltip" class = 'users-show'  title="ข้อมูลผู้ใช้งานทั่วไป"   style='cursor:pointer'>ข้อมูลผู้ใช้งานทั่วไป</div>`;
      return Div;
    };
    this.icnoUsersShow.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("UsersShow"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("UsersShow"));

    $(".users-show").on("click", () => {
      if (this.idnControllerUsers == 0) {
        console.log("users is enable..");
        $("#UsersShow").css({
          filter: `drop-shadow(-1px 0px 6px rgba(33, 81, 159))`,
        });
        this.idnControllerUsers = 1;
        $("#mydivUsersShow").show();
        this.displayUsers = true;
      } else {
        $("#UsersShow").css({
          filter: `none`,
        });
        $("#mydivUsersShow").hide();
        this.idnControllerUsers = 0;
        this.clearUsersMarker();
      }
    });

    // ===================================================================================
    // Layers Shops on Maps
    this.icnoShopsShow.onAdd = () => {
      var Div = L.DomUtil.create("div");
      Div.id = "ShopsShow";
      Div.innerHTML = `<div id="buttonMap" data-toggle="tooltip" class = 'shops-show'  title="ข้อมูลร้านค้า/บริการ"   style='cursor:pointer'>ข้อมูลร้านค้า/บริการ</div>`;
      return Div;
    };
    this.icnoShopsShow.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("ShopsShow"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("ShopsShow"));

    $(".shops-show").on("click", () => {
      if (this.idnControllerShops == 0) {
        console.log("shops is enable..");
        $("#ShopsShow").css({
          filter: `drop-shadow(-1px 0px 6px rgba(33, 81, 159))`,
        });
        this.idnControllerShops = 1;
        $("#mydivShopsShow").show();
        this.displayShops = true;
      } else {
        $("#ShopsShow").css({
          filter: `none`,
        });
        $("#mydivShopsShow").hide();
        this.idnControllerShops = 0;
        this.clearShopsMarker();
      }
    });

    // ===================================================================================
    // Layers Base Map Controll
    this.baseLayers = {
      "<img src='assets/leaflet/img/worldwide2.png' width='10' height='10'>&nbsp;World Street Map":
        this.deemapWorldStreetMap,
      "<img src='assets/leaflet/img/internet.png' width='10' height='10'>&nbsp;Deemap Dark":
        this.deemapNigth,
      "<img src='assets/leaflet/img/worldwide.png' width='10' height='10'>&nbsp;Deemap Light":
        this.deemapLight,
    };

    this.parcel.addTo(this.map);
    // L.control.layers(this.baseLayers).addTo(this.map);
    this.layerControl = L.control.layers(this.baseLayers).addTo(this.map);

    document.getElementsByClassName(
      "leaflet-control-zoom leaflet-bar leaflet-control"
    )[0].style.display = "none";

    // --------------------Extend------------------------
    this.exten.onAdd = () => {
      var Div = L.DomUtil.create("div");
      Div.id = "bntexten";
      Div.innerHTML = `
			<img src ="assets/leaflet/img/exten.png"  title="Zoom to Exten" class = 'exten' style='position:absolute; cursor:pointer; right:1px; top:-110px; width:35px'>`;
      return Div;
    };
    this.exten.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("bntexten"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("bntexten"));

    $("#bntexten").on("click", () => {
      this.map.setView([13.783278, 100.59288], 10);
      this.clearMarker();
    });

    // --------------------Zoom in------------------------
    this.zoomIn.onAdd = () => {
      var Div = L.DomUtil.create("div");
      Div.id = "zoomin";
      Div.innerHTML = `
				<img src ="assets/leaflet/img/in.png" title="Zoom In"  class = 'zoomin' style='position:absolute; cursor:pointer; right:1px; top:-60px; width:35px'>`;
      return Div;
    };

    this.zoomIn.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("zoomin"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("zoomin"));

    $("#zoomin").on("click", () => {
      this.map.setZoom(this.map.getZoom() + 1);
    });

    // --------------------Zoom out------------------------
    this.zoomOut.onAdd = () => {
      var Div = L.DomUtil.create("div");
      Div.id = "zoomout";
      Div.innerHTML = `
			<img src ="assets/leaflet/img/out.png" title="Zoom Out" class = 'zoomout'  style='position:absolute; cursor:pointer; right:1px; top:-10px; width:35px'>`;
      return Div;
    };
    this.zoomOut.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("zoomout"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("zoomout"));

    $("#zoomout").on("click", () => {
      this.map.setZoom(this.map.getZoom() - 1);
    });

    //////////////////////////////////////////////////////////////////
    L.control
      .coordinates({
        position: "bottomleft",
      })
      .addTo(this.map);
    //add configured controls
    L.control.coordinates({
      position: "bottomleft",
      decimals: 2,
      decimalSeperator: ",",
      labelTemplateLat: "Latitude: {y}",
      labelTemplateLng: "Longitude: {x}",
    });

    //Load Scalebar
    L.control.scale().addTo(this.map);

    // History control
    new L.HistoryControl({
      position: "bottomleft",
    }).addTo(this.map);

    this.alert.onAdd = function () {
      var div = L.DomUtil.create("div");
      div.id = "alal";
      div.innerHTML = ` 
				<div  id="mydiv">
					<div id="mydivheader" class="text-white" >Click here to move</div>
					<div class="card card-body " style="background-color: rgb(59, 56, 56);">
						<div class="form-group">
							<h4 class="text-white" for="latitude">ค้นหาพิกัด</h4>
							<label class="text-white" for="latitude" style="font-size: 15px;">ละติจูด (latitude)</label>
							<input class="form-control" type="text" name="latitude" id="latitude" placeholder="latitude"  style="width: 150px;>
						</div>
						<div class="form-group">
						<br/>
							<label class="text-white" for="longitude" style="font-size: 15px;">ลองจิจูด (longitude)</label>
							<input class="form-control" type="text" name="longitude" id="longitude" placeholder="longitude"  style="width: 150px;>
							<br/>
						</div>
						<div class=" justify-content-center">
								<br/> <span class="btn"><input type="button" class="btn btn-success searLatLong" data-dismiss="modal" value="ค้นหา"></span>
								<span class="btn"><input type="button" class="btn btn-primary clearSearch"  value="ลบการค้นหา"></span>   
						</div>
					</div>
				</div>
				
				<div  id="mydivSearch">
<div id="mydivSearchheader" class="text-white">Click here to move</div>

<div class="card card-body " style="background-color: rgb(59, 56, 56);">
  <div class="form-group">
  
  <h4><label class="text-white" for="location">ค้นหาสถานที่</label><br/></h4>
      <input class="form-control" type="text" name="textSearch" id="locationSearch" placeholder="Search"  style="width: 250px">
  </div>

  <div class=" justify-content-center">
          <br/> <span class="btn"><input type="button" class="btn btn-success searchLocation" data-dismiss="modal" value="ค้นหา"></span>
  </div>

  <h6> <label class="text-white" for="location"><div id="resultSearchLocation"></div></label><h6>
  </div>
</div>
`;
      return div;
    };
    this.alert.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("alal"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("alal"));

    //Make the DIV element draggagle:
    this.dragElement(document.getElementById("mydiv"));
    this.dragElement(document.getElementById("mydivShopsShow"));
    this.dragElement(document.getElementById("mydivUsersShow"));
    this.map.addLayer(this.noed);

    var LAT, LON;
    $(".searLatLong").on("click", () => {
      LAT = $("#latitude").val();
      LON = $("#longitude").val();
      this.noed.clearLayers();
      this.map.flyTo(new L.LatLng(LAT, LON), 17);

      var LATlatitude = this.toDegreesMinutesAndSeconds(LAT);
      var latitudeCardinal = LAT >= 0 ? "N" : "S";

      var LONlongitude = this.toDegreesMinutesAndSeconds(LON);
      var longitudeCardinal = LON >= 0 ? "E" : "W";
      this.marker1 = L.marker([LAT, LON], {
        alt: "The Big I",
      })
        .addTo(this.noed)
        .bindPopup(
          "<b>" +
            "Degrees : " +
            "</b>" +
            "<b>" +
            "latitude :  " +
            LAT +
            "</b>" +
            "<b>" +
            " " +
            "longitude :  " +
            LON +
            "</b>" +
            "<br>" +
            "<b>" +
            "DMS : " +
            "</b>" +
            "<b>" +
            latitudeCardinal +
            " " +
            LATlatitude +
            "\n" +
            longitudeCardinal +
            " " +
            LONlongitude +
            "</b>" +
            "<br>"
        )
        .openPopup();
    });

    $(".clearSearch").on("click", () => {
      LAT = $("#latitude").val("");
      LON = $("#longitude").val("");
      this.noed.clearLayers();
    });

    this.icnoIdentifyLocation.onAdd = () => {
      var Div = L.DomUtil.create("div");
      Div.id = "IdentifyLocation";
      Div.innerHTML = `
				<img src ="assets/leaflet/img/ii.png" data-toggle="tooltip" class = 'identify' title="สอบถามข้อมูลจากตำแหน่ง"   style='position:absolute;cursor:pointer; top:-120px; right:1px; width:35px'>
			`;
      return Div;
    };
    this.icnoIdentifyLocation.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("IdentifyLocation"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("IdentifyLocation"));

    //  controller TOOLS
    var popup = L.popup();

    var idnController = 0;
    $("#IdentifyLocation").on("click", () => {
      if (idnController == 0) {
        console.log("identify is enable..");
        $("#IdentifyLocation").css({
          filter: `drop-shadow(-1px 0px 6px rgba(0,213,255))`,
        });
        idnController = 1;
        // event work with Map
        this.map.off("click");
        this.map.on("click", (e) => {
          this.onMapClick(e);
        });
      } else {
        $("#IdentifyLocation").css({
          filter: `none`,
        });
        console.log("identify is disable..");
        idnController = 0;
        this.map.off("click");
        this.map.closePopup();
        if (
          document.querySelectorAll(
            "div.leaflet-popup.popupidentify.leaflet-zoom-animated"
          ).length != 0
        ) {
          document.querySelectorAll(
            "div.leaflet-popup.popupidentify.leaflet-zoom-animated"
          )[0].style.display = "none";
        }
      }
    });

    this.icnoSearch.onAdd = () => {
      var Div = L.DomUtil.create("div");
      Div.id = "Search";
      Div.innerHTML = `
			<img src ="assets/leaflet/img/Search.png" data-toggle="tooltip" title="ค้นหาสถานที่"
			class = 'Search'  style='position:absolute; cursor:pointer; right:1px; top:-190px; width:35px'>
			
	`;
      return Div;
    };
    this.icnoSearch.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("Search"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("Search"));
    $(".searchLocation").on("click", async () => {
      this.clearMarker();
      document.getElementById("resultSearchLocation").innerText = "";
      //API LINK : https://www.deemap.com/DeeMap2WS_GC_dtc-ws/jsonSearch.jsp?start=0&limit=50&query=QUERY&mode=0&bbox=&dsrc=DeeMap2
      //QUERY is input keyword.
      var location_name = $("#locationSearch").val();
      await this.axios
        .get(
          `https://api.deemap.com/service/search/?keyword=${location_name}&key=abfb48cd54789d39f49812fb8977e722`
        )
        .then((response) => {
          console.log(response.data.data);
          var data = response.data.data;
          if (data.length == 0) {
            this.$toast.add({
              severity: "error",
              summary: "ไม่พบข้อมูล",
              detail: "กรุณากรอกข้อมูลใหม่",
              life: 3000,
            });
          } else {
            (document.getElementById(
              "resultSearchLocation"
            ).innerText = `สถานที่ ${data[0].texts}
                                                                        \nละติจูด\n${data[0].LAT}
                                                                        \nnลองจิจูด\n${data[0].LON}`),
              this.map.flyTo(new L.LatLng(data[0].LAT, data[0].LON), 17),
              this.mapMarkers.push(
                L.marker([data[0].LAT, data[0].LON])
                  .addTo(this.map)
                  .bindPopup(popup.setContent(`สถานที่ ${data[0].texts}`))
                  .openPopup()
              );
          }
        });
    });

    //  controller TOOLS
    var idnController3 = 0;
    $(".Search").on("click", () => {
      if (idnController3 == 0) {
        console.log("Search is enable..");
        $("#Search").css({
          filter: `drop-shadow(-1px 0px 6px rgba(0,213,255))`,
        });

        idnController3 = 1;
        // event work with Map
        $("#mydivSearch").show();
        this.map.off("click");
        this.map.on("click", function (ev) {
          console.log(ev);
        });
      } else {
        $("#Search").css({
          filter: `none`,
        });

        $("#mydivSearch").hide();
        console.log("Search is disable..");
        document.getElementById("locationSearch").value = "";
        document.getElementById("resultSearchLocation").innerText = "";
        // document.getElementById('coloridentify').style.color = 'black';
        idnController3 = 0;
        this.map.off("click");
        this.map.closePopup();
      }
    });

    this.iconFindLocation.onAdd = () => {
      var Div = L.DomUtil.create("div");
      Div.id = "FindLocation";
      Div.innerHTML = `
				<img src ="assets/leaflet/img/xy.png" data-toggle="tooltip" title="ค้นหาพิกัด" class = 'xy'  style='position:absolute; cursor:pointer; right:1px; top:-140px; width:35px'>
			`;
      return Div;
    };
    this.iconFindLocation.addTo(this.map);
    L.DomEvent.disableClickPropagation(L.DomUtil.get("FindLocation"));
    L.DomEvent.disableScrollPropagation(L.DomUtil.get("FindLocation"));

    // controller TOOLS
    var idnController2 = 0;
    // document.getElementById('FindLocation').onclick = function() {
    $(".xy").on("click", () => {
      if (idnController2 == 0) {
        console.log("FindLocation is enable..");
        $("#FindLocation").css({
          filter: `drop-shadow(-1px 0px 6px rgba(0,213,255))`,
        });

        idnController2 = 1;
        // event work with Map
        $("#mydiv").show();

        this.map.off("click");
        this.map.on("click", function (ev) {
          console.log(ev);
        });
      } else {
        $("#FindLocation").css({
          filter: `none`,
        });

        $("#mydiv").hide();

        console.log("FindLocation is disable..");
        idnController2 = 0;
        this.map.off("click");
        this.map.closePopup();
      }
    });

    L.control.ruler(this.options).addTo(this.map);
    this.measureControl.addTo(this.map);
    this.map.on("measurefinish", function (evt) {
      console.log(evt);
    });
    this.map.addControl(this.marker_controls);
  },

  methods: {
    style: function () {
      return {
        weight: 1,
        opacity: 1,
        color: "#000fff",
        fillOpacity: 0.2,
        fillColor: "#ffffff",
      };
    },

    closeData() {
      this.systemShopModal = false;
      this.systemUserModal = false;
    },

    httpimg(img) {
      return this.$url_image + img;
    },

    replaceByDefault(e) {
      e.target.src = require("../../public/assets/pmg-userprofile.png");
    },

    highlightFeature: function (e) {
      var layer = e.target;
      this.map.update(layer.feature.properties);
    },

    zoomToFeature: function (e) {
      this.map.fitBounds(e.target.getBounds());
    },

    onEachFeature2: function (feature, layer) {
      layer.on({
        click: this.zoomToFeature(),
      });
    },

    onEachFeature: function (feature, layer) {
      // does this feature have a property named popupContent?
      if (feature.properties && feature.properties.popupContent) {
        layer.bindPopup(feature.properties.popupContent);
      }
    },

    //ฟังก์ชั่นการซูมเมื่อค้นหาจากค่า lat long
    bonceposition: function (lat, long) {
      this.map.setView([lat, long], 23);
      L.marker([lat, long]).addTo(this.map);
    },

    dragElement: function (elmnt) {
      var pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;
      if (document.getElementById(elmnt.id + "header")) {
        /* if present, the header is where you move the DIV from:*/
        document.getElementById(elmnt.id + "header").onmousedown =
          dragMouseDown;
      } else {
        /* otherwise, move the DIV from anywhere inside the DIV:*/
        elmnt.onmousedown = dragMouseDown;
      }

      function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = elmnt.offsetTop - pos2 + "px";
        elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
      }

      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
      }
    },

    ///ฟังก์ชั่นในการแปลงเป็น DMS
    toDegreesMinutesAndSeconds: function (coordinate) {
      var absolute = Math.abs(coordinate);
      var degrees = Math.floor(absolute);
      var minutesNotTruncated = (absolute - degrees) * 60;
      var minutes = Math.floor(minutesNotTruncated);
      var seconds = Math.floor((minutesNotTruncated - minutes) * 60);

      return degrees + "°" + minutes + "'" + seconds + '"';
    },

    clearMarker() {
      for (var i = 0; i < this.mapMarkers.length; i++) {
        this.map.removeLayer(this.mapMarkers[i]);
      }

      for (var j = 0; j < this.mapMarkersIcon.length; j++) {
        this.map.removeLayer(this.mapMarkersIcon[j]);
      }
    },

    clearShopsMarker() {
      for (var i = 0; i < this.mapShopsMarkers.length; i++) {
        this.map.removeLayer(this.mapShopsMarkers[i]);
      }

      for (var j = 0; j < this.mapShopsMarkersIcon.length; j++) {
        this.map.removeLayer(this.mapShopsMarkersIcon[j]);
      }

      for (var k = 0; k < this.mapShopsMarkersCircle.length; k++) {
        this.map.removeLayer(this.mapShopsMarkersCircle[k]);
      }
    },

    clearUsersMarker() {
      for (var i = 0; i < this.mapUsersMarkers.length; i++) {
        this.map.removeLayer(this.mapUsersMarkers[i]);
      }

      for (var j = 0; j < this.mapUsersMarkersIcon.length; j++) {
        this.map.removeLayer(this.mapUsersMarkersIcon[j]);
      }

      for (var k = 0; k < this.mapUsersMarkersCircle.length; k++) {
        this.map.removeLayer(this.mapUsersMarkersCircle[k]);
      }
    },

    selectNewCoordinate() {
      document.getElementById("map").style.cursor = "crosshair";
      this.map.on("click", (e) => {
        this.event_lat = e.latlng.lat;
        this.event_lng = e.latlng.lng;
      });
    },

    acceptNumber() {
      var x = this.event_call_phone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.event_call_phone = !x[2]
        ? x[1]
        : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
    },

    async confirmEvent() {
      if (
        this.event_name == "" ||
        this.event_lat == "" ||
        this.event_lng == "" ||
        this.event_date == "" ||
        this.event_time == "" ||
        this.disaster_type_select == null ||
        this.event_location == "" ||
        this.event_call_name == "" ||
        this.event_call_phone == ""
      ) {
        if (this.event_name == "") {
          this.error_event_name = true;
        }
        if (this.event_lat == "") {
          this.error_event_lat = true;
        }
        if (this.event_lng == "") {
          this.error_event_lng = true;
        }
        if (this.event_date == "") {
          this.error_event_date = true;
        }
        if (this.event_time == "") {
          this.error_event_time = true;
        }
        if (this.disaster_type_select == null) {
          this.error_disaster_type_select = true;
        }
        if (this.event_location == "") {
          this.error_event_location = true;
        }
        if (this.event_call_name == "") {
          this.error_event_call_name = true;
        }
        if (this.event_call_phone == "") {
          this.error_event_call_phone = true;
        }
      } else {
        var date_add;
        const date = new Date(this.event_time);
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          date
        );
        const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          date
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          date
        );
        const h = date.getHours();
        const m = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
        const s = (date.getSeconds() < 10 ? "0" : "") + date.getSeconds();
        date_add = `${ye}-${mo}-${da} ${h}:${m}:${s}`;

        var table = [];
        if (this.url_image != null) {
          table.push({
            type: "รูปภาพ",
            name: `${this.event_image_name}`,
            detail: "-",
            file: `${this.$refs.event_image.innerText}`,
            ext: this.download_ext,
          });
        }

        await this.axios.post(`${this.$url_service}/disaster`, {
          body: {
            topic: "add-disaster-from-map",
            name: this.event_name,
            date: date_add,
            disaster_type: this.disaster_type_select.system_id,
            disaster_locate: this.event_location,
            status: "onworking",
            call_name: this.event_call_name,
            call_phone: this.event_call_phone,
            lat: this.event_lat,
            lon: this.event_lng,
            file_table: table,
            userOrg: this.getUserOrganize(),
          },
        });

        this.$toast.add({
          severity: "success",
          summary: "ทำการเพิ่มจุดสำเร็จ",
          detail: "เพิ่มจุดสาธารณภัย",
          life: 3000,
        });
        this.clearData();
      }
    },

    clearData() {
      $("#mydivReport").hide();
      this.event_name = "";
      this.disaster_type_select = null;
      this.event_location = "";
      this.event_call_name = "";
      this.event_call_phone = "";
      this.url_image = null;
      this.idnController3 = 0;
      document.getElementById("map").style.cursor = "grab";
      $("#Report").css({ filter: `none` });
      this.error_event_name = false;
      this.error_event_lat = false;
      this.error_event_lng = false;
      this.error_event_date = false;
      this.error_event_time = false;
      this.error_disaster_type_select = false;
      this.error_event_location = false;
      this.error_event_call_name = false;
      this.error_event_call_phone = false;
    },

    clearData2() {
      this.event_name = "";
      this.event_lat = "";
      this.event_lng = "";
      this.event_date = "";
      this.event_time = "";
      this.disaster_type_select = null;
      this.event_location = "";
      this.event_call_name = "";
      this.event_call_phone = "";
      this.url_image = null;
      document.getElementById("uploadFile").value = "";

      this.error_event_name = false;
      this.error_event_lat = false;
      this.error_event_lng = false;
      this.error_event_date = false;
      this.error_event_time = false;
      this.error_disaster_type_select = false;
      this.error_event_location = false;
      this.error_event_call_name = false;
      this.error_event_call_phone = false;
    },

    clearDataShops() {
      $("#mydivShopsShow").hide();
      this.shopsEvent_ShopsType = null;
      this.idnControllerShops = 0;
      this.clearShopsMarker();
      $("#ShopsShow").css({ filter: `none` });
    },

    clearDataUsers() {
      $("#mydivUsersShow").hide();
      this.usersEvent_UsersType = null;
      this.idnControllerUsers = 0;
      this.clearUsersMarker();
      $("#UsersShow").css({ filter: `none` });
    },

    clearDataShopsDetail() {
      this.dataOnClickShopsMarker = null;
      this.imgOnClickShopsMarker = null;
      this.systemShopModal = false;
    },

    clearDataUsersDetail() {
      this.dataOnClickUsersMarker = null;
      this.dataOnClickUsersMarker = null;
    },

    clearShopsShow() {
      this.shopsEvent_ShopsType = null;
    },

    clearUsersShow() {
      this.usersEvent_UsersType = null;
    },

    adjustWindow() {
      if (this.icon == "pi pi-window-minimize pointer p-mr-3") {
        this.display = false;
      } else {
        this.event_time = new Date();
        this.display = true;
      }
    },

    adjustWindowShops() {
      if (this.iconReportShops == "pi pi-window-minimize pointer p-mr-3") {
        this.displayShops = false;
      } else {
        this.displayShops = true;
      }
    },

    adjustWindowUsers() {
      if (this.iconReportUsers == "pi pi-window-minimize pointer p-mr-3") {
        this.displayUsers = false;
      } else {
        this.displayUsers = true;
      }
    },

    onFileChange(e) {
      if (e.target.files[0] != undefined) {
        if (e.target.files[0].type.split("/")[0] == "image") {
          this.download_ext = e.target.files[0].type.split("/")[1];
          const file = e.target.files[0];
          this.event_image_name = e.target.files[0].name.split(".")[0];
          this.url_image = URL.createObjectURL(file);

          var reader = new FileReader();

          reader.onload = (e) => {
            var img = document.createElement("img");
            img.onload = () => {
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);

              var MAX_WIDTH = 150;
              var MAX_HEIGHT = 180;
              var width = img.width;
              var height = img.height;

              if (width > height) {
                if (width > MAX_WIDTH) {
                  height *= MAX_WIDTH / width;
                  width = MAX_WIDTH;
                }
              } else {
                if (height > MAX_HEIGHT) {
                  width *= MAX_HEIGHT / height;
                  height = MAX_HEIGHT;
                }
              }
              canvas.width = width;
              canvas.height = height;
              ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, width, height);

              var dataurl = canvas.toDataURL("image/png");
              let console = {};
              let logger = document.getElementById("event_image");
              console.log = (text) => {
                let txt = document.createTextNode(text);
                logger.appendChild(txt);
              };
              console.log(dataurl);
            };
            img.src = e.target.result;
          };
          reader.readAsDataURL(file);
        } else {
          this.$toast.add({
            severity: "error",
            summary: "ประเภทไฟล์ผิดพลาด",
            detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
            life: 3000,
          });
          this.url_image = null;
          document.getElementById("uploadFile").value = "";
        }
      } else {
        this.url_image = null;
      }
    },

    async onMapClick(data) {
      var lat = data.latlng.lat;
      var lng = data.latlng.lng;
      //Old link = https://www.deemap.com/DeeMap2WS_aeon/geocoding_aeon.jsp?lat=${lat}&lon=${lng}&radius=1
      await this.axios
        .get(
          `https://api.deemap.com/service/geocode/lat=${lat}/lon=${lng}/key=0feb00d7e64c5686bf434b9b90ab2d3c`
        )
        .then((response) =>
          this.getPopupFromIdentify(data.latlng, response.data.data[0])
        );
    },

    getPopupFromIdentify: function (point, json) {
      var popup = L.popup({ className: "popupidentify" });
      popup
        .setLatLng(point)
        .setContent(
          " ตำบล : " +
            json.TAM_TNAME +
            "<br>" +
            " อำเภอ : " +
            json.AMP_TNAME +
            "<br>" +
            " จังหวัด : " +
            json.PROV_TNAME +
            "<br>" +
            " ละติจูด : " +
            point.lat +
            "<br>" +
            " ลองจิจูด : " +
            point.lng +
            "<br>"
        )
        .addTo(this.map);
    },

    async confirmShopsShow() {
      await this.axios
        .get(
          `${this.$url_service}/shops/` +
            (this.shopsEvent_ShopsType.shop_typ_id == "styp-99999"
              ? "all"
              : this.shopsEvent_ShopsType.shop_typ_id),
          {
            body: {},
          }
        )
        .then((response) => {
          this.systemShopsData_table = response.data[0].data;
          this.addMapShopsMarker(response.data[0].data);
        });
    },

    addMapShopsMarker(data) {
      for (var i = 0; i < this.mapShopsMarkers.length; i++) {
        this.map.removeLayer(this.mapShopsMarkers[i]);
      }

      for (var j = 0; j < this.mapShopsMarkersIcon.length; j++) {
        this.map.removeLayer(this.mapShopsMarkersIcon[j]);
      }

      for (var k = 0; k < this.mapShopsMarkersCircle.length; k++) {
        this.map.removeLayer(this.mapShopsMarkersCircle[k]);
      }

      if (data.length == 0) {
        this.$toast.add({
          severity: "error",
          summary: "ไม่พบข้อมูล",
          detail: "กรุณากรอกคำค้นหาใหม่",
          life: 3000,
        });
      } else {
        this.displayShops = false;
        for (let k = 0; k < data.length; k++) {
          if (data[0].shop_email != "") {
            var new_icon = null;
            if (data[k].shop_status == "1") {
              new_icon = new L.Icon({
                iconUrl: require(`../../public/assets/leaflet/img/status/pmg-open.png`),
                iconSize: 36,
              });
            } else {
              new_icon = new L.Icon({
                iconUrl: require(`../../public/assets/leaflet/img/status/pmg-close.png`),
                iconSize: 36,
              });
            }

            var myFeatureGroup = L.featureGroup()
              .addTo(this.map)
              .on("click", this.clickShopsMarker);
            var marker = L.marker([data[k].shop_rglat, data[k].shop_rglon], {
              icon: new_icon,
            }).addTo(myFeatureGroup);
            marker.dataShow = data[k];
            this.mapShopsMarkersIcon.push(marker);

            var filterCircle = L.circle(
              L.latLng(data[k].shop_rglat, data[k].shop_rglon),
              5000,
              {
                opacity: 0.5,
                weight: 1,
                fillOpacity: 0.2,
              }
            ).addTo(this.map);

            this.mapShopsMarkersCircle.push(filterCircle);
          }
        }

        if (data.length > 0) {
          if (data[0].shop_email != "") {
            this.map.setView([data[0].shop_rglat, data[0].shop_rglon], 10);
          } else {
            this.map.setView([13.6750394, 100.6037526], 10);
          }
        } else {
          this.map.setView([13.6750394, 100.6037526], 10);
        }
      }
    },

    async confirmUsersShow() {
      console.log(
        `${this.$url_service}/members/` + this.usersEvent_UsersType.user_typ_id
      );
      await this.axios
        .get(
          `${this.$url_service}/members/` +
            this.usersEvent_UsersType.user_typ_id,
          {
            body: {},
          }
        )
        .then((response) => {
          this.systemUsersData_table = response.data[0].data;
          this.addMapUsersMarker(response.data[0].data);
        });
    },

    addMapUsersMarker(data) {
      for (var i = 0; i < this.mapUsersMarkers.length; i++) {
        this.map.removeLayer(this.mapUsersMarkers[i]);
      }

      for (var j = 0; j < this.mapUsersMarkersIcon.length; j++) {
        this.map.removeLayer(this.mapUsersMarkersIcon[j]);
      }

      for (var k = 0; k < this.mapUsersMarkersCircle.length; k++) {
        this.map.removeLayer(this.mapUsersMarkersCircle[k]);
      }

      if (data.length == 0) {
        this.$toast.add({
          severity: "error",
          summary: "ไม่พบข้อมูล",
          detail: "กรุณากรอกคำค้นหาใหม่",
          life: 3000,
        });
      } else {
        this.displayUsers = false;
        for (let k = 0; k < data.length; k++) {
          if (data[k].memb_email != "") {
            //memb_email
            var new_icon = null;
            if (data[k].memb_flag == "1") {
              new_icon = new L.Icon({
                iconUrl: require(`../../public/assets/leaflet/img/status/pmg-active.png`),
                iconSize: 36,
              });
            } else {
              new_icon = new L.Icon({
                iconUrl: require(`../../public/assets/leaflet/img/status/pmg-none-active.png`),
                iconSize: 36,
              });
            }

            var myFeatureGroup = L.featureGroup()
              .addTo(this.map)
              .on("click", this.clickUsersMarker);
            var marker = L.marker([data[k].memb_dvlat, data[k].memb_dvlon], {
              icon: new_icon,
            }).addTo(myFeatureGroup);
            marker.dataShow = data[k];
            this.mapUsersMarkersIcon.push(marker);

            var filterCircle = L.circle(
              L.latLng(data[k].memb_dvlat, data[k].memb_dvlon),
              5000,
              {
                opacity: 0.5,
                weight: 1,
                fillOpacity: 0.2,
                color: "orange",
              }
            ).addTo(this.map);

            this.mapUsersMarkersCircle.push(filterCircle);
          }
        }

        if (data.length > 0) {
          if (data[k].memb_email != "") {
            this.map.setView([data[0].memb_dvlat, data[0].memb_dvlon], 10);
          } else {
            this.map.setView([13.6750394, 100.6037526], 10);
          }
        } else {
          this.map.setView([13.6750394, 100.6037526], 10);
        }
      }
    },

    clickShopsMarker(event) {
      console.log(event.layer.dataShow);
      this.dataOnClickShopsMarker = event.layer.dataShow;

      if (this.dataOnClickShopsMarker.shop_status == "0") {
        this.dataOnClickShopsMarker.shop_status = "ปิดให้บริการ";
      } else {
        this.dataOnClickShopsMarker.shop_status = "เปิดให้บริการ";
      }

      this.systemShopModal = true;
    },

    clickUsersMarker(event) {
      console.log(event.layer.dataShow);
      this.systemUserModal = true;
      this.dataOnClickUsersMarker = event.layer.dataShow;
      this.dataOnClickUsersMarker.memb_dvdate = new Date(
        Date.parse(this.dataOnClickUsersMarker.memb_dvdate)
      );
      this.dataOnClickUsersMarker.memb_rgdate = new Date(
        Date.parse(this.dataOnClickUsersMarker.memb_rgdate)
      );
      this.systemUserModal = true;
    },

    checkStatus(status) {
      if (status == "0") {
        // return `<span style="color: #fe260a; font-weight: bold">ปิดให้บริการ</span>`;
        return `<span style="color: #fe260a;">ปิดให้บริการ</span>`;
      } else {
        return `<span style="color: #23D91C;">เปิดให้บริการ</span>`;
      }
    },

    formatDatetime(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },

    formatTime(datetime) {
      return moment(datetime).format("HH:mm:ss");
    },
  },

  watch: {
    event_lat(val) {
      if (val != "") {
        document.getElementById("map").style.cursor = "grab";
        this.map.off("click");
      }
    },

    displayShops(val) {
      if (val == false) {
        document.getElementById("mydivShopsShow").style.width = "fit-content";
        this.styleIconShops = "margin-left:50px";
        this.iconReportShops = "pi pi-window-maximize pointer p-mr-3";
      } else {
        document.getElementById("mydivShopsShow").style.width = "400px";
        this.styleIconShops = "margin-left:175px";
        this.iconReportShops = "pi pi-window-minimize pointer p-mr-3";
      }
    },

    displayUsers(val) {
      if (val == false) {
        document.getElementById("mydivUsersShow").style.width = "fit-content";
        this.styleIconUsers = "margin-left:50px";
        this.iconReportUsers = "pi pi-window-maximize pointer p-mr-3";
      } else {
        document.getElementById("mydivUsersShow").style.width = "400px";
        this.styleIconUsers = "margin-left:184px";
        this.iconReportUsers = "pi pi-window-minimize pointer p-mr-3";
      }
    },

    event_date(val) {
      if (val == null) {
        this.event_date = "";
      }
    },
  },
};
</script>

<style scoped>
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}

#map {
  height: calc(100vh - 194px);
  margin: -15px;
}

.history-control.leaflet-bar.horizontal a {
  display: inline-block;
  border-bottom: 0;
  border-radius: 5px;
  padding-top: 2px;
  border-right: 2px solid #5372a5;
  color: rgb(255, 255, 255);
  background-color: #21529f;
}

.leaflet-control-coordinates {
  left: -5px;
  color: #fffefe;
  background-color: #21529f;
  cursor: pointer;
}

.leaflet-control-scale-line {
  border: 2px solid #777;
  border-top: none;
  line-height: 1.1;
  padding: 2px 5px 1px;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  color: #fffefe;
  background: #fff;
  background: #21529f;
}

/* alert */
#mydiv {
  display: none;
  position: absolute;
  top: 60px;
  z-index: 1000;
  left: 50px;
  background-color: #f1f1f1;
  text-align: center;
  border: 1px solid #d3d3d3;
}

#mydivheader {
  padding: 10px;
  cursor: move;
  z-index: 10;
  background-color: #21529f;
  color: #fff;
}

#mydivReport {
  display: none;
  position: absolute;
  top: 300px;
  left: 30px;
  z-index: 1000;
  background-color: #f1f1f1;
  border: 1px solid #d3d3d3;
  width: 600px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

#mydivReportheader {
  padding: 10px;
  cursor: move;
  z-index: 10;
  background-color: #21529f;
  color: #fff;
}

#mydivUsersShowheader {
  padding: 10px;
  cursor: move;
  z-index: 10;
  background-color: #21529f;
  color: #fff;
}

#mydivShopsShowheader {
  padding: 10px;
  cursor: move;
  z-index: 10;
  background-color: #21529f;
  color: #fff;
}

#mydivAddEventHeader {
  padding: 10px;
  cursor: move;
  z-index: 10;
  background-color: #21529f;
  color: #fff;
}

#mydivSearch {
  display: none;
  position: absolute;
  top: 50px;
  left: 50px;
  z-index: 1000;
  background-color: #f1f1f1;
  text-align: center;
  border: 1px solid #d3d3d3;
}

#mydivSearchheader {
  padding: 10px;
  cursor: move;
  z-index: 10;
  background-color: #21529f;
  color: #fff;
}

#mydivUsersShow {
  display: none;
  position: absolute;
  top: 200px;
  left: 10px;
  z-index: 1000;
  background-color: #f1f1f1;
  border: 1px solid #d3d3d3;
  width: 400px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

#mydivShopsShow {
  display: none;
  position: absolute;
  top: 200px;
  left: 10px;
  z-index: 1000;
  background-color: #f1f1f1;
  border: 1px solid #d3d3d3;
  width: 400px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

.myClass {
  padding-top: -50%;
  padding-left: 50%;
}

.collapsible {
  background-color: rgb(0, 124, 124);
  color: white;
  cursor: pointer;
  padding: 5px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

.active,
.collapsible:hover {
  background-color: #555;
}

.content {
  padding: 0 18px;
  display: none;
  overflow: hidden;
  background-color: #ffffff;
}

/*ปรับตำแหน่งเครื่องมือวาด */
.leaflet-bar {
  background-color: #21529f;
  color: rgb(255, 255, 255);
  left: -5px;
  /* top: -125px; */
}

.leaflet-bar a {
  /* background-color: #ff00c8; */
  background-color: #21529f;
  border-bottom: 1px solid #ccc;
  width: 26px;
  height: 26px;
  line-height: 26px;
  display: block;
  text-align: center;
  text-decoration: none;
  color: rgb(255, 255, 255);
}

a.polyline-measure-controlOnBgColor,
a.polyline-measure-controlOnBgColor:hover {
  background-color: rgb(235, 221, 31);
}

a.polyline-measure-clearControl:active {
  background-color: rgb(255, 136, 0);
}

.Search:hover {
  border-radius: 20%;
  filter: drop-shadow(-1px 0px 6px rgba(0, 213, 255));
}

.xy:hover {
  border-radius: 50%;
  filter: drop-shadow(-1px 0px 6px rgba(0, 213, 255));
}

#buttonMap {
  font-family: "Kanit";
  color: white;
  background-color: #21529f;
  border-radius: 10px;
  border: 2px solid white;
  min-width: max-content;
  text-align: center;
  font-size: 16px;
  padding: 5px 30px;
}

.report:hover {
  border-radius: 20%;
  filter: drop-shadow(-1px 0px 6px rgba(0, 213, 255));
}

.report-show:hover {
  border-radius: 20%;
  filter: drop-shadow(-1px 0px 6px rgba(0, 213, 255));
}

.zoomin:hover {
  border-radius: 50%;
  filter: drop-shadow(-1px 0px 6px rgba(0, 213, 255));
}

.zoomout:hover {
  border-radius: 50%;
  filter: drop-shadow(-1px 0px 6px rgba(0, 213, 255));
}

.identify:hover {
  border-radius: 50%;
  filter: drop-shadow(-1px 0px 6px rgba(0, 213, 255));
}

.exten:hover {
  border-radius: 50%;
  filter: drop-shadow(-1px 0px 6px rgba(0, 213, 255));
}

.edituserimg {
  /* background-image: url(https://i.stack.imgur.com/3keSg.png) !important; */
  background-color: #21529f;
  background-size: 54px 54px;
  border-radius: 10%;
  border: 2px solid #555;
  width: 125px;
  height: 125px;
  margin-bottom: -100px;
  margin-left: 0px;
}

.edituserimg:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
  cursor: pointer;
}

.shopimg {
  /* background-image: url(https://i.stack.imgur.com/3keSg.png) !important; */
  background-color: #21529f;
  background-size: 128px 128px;
  border-radius: 10%;
  border: 2px solid #555;
  width: 128px;
  height: 128px;
  margin-bottom: 12px;
  margin-left: 0px;
}

.shopimg:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
  cursor: pointer;
}

/* แต่ง  control-layers******************/
.leaflet-control-layers-toggle {
  background-image: url(https://i.stack.imgur.com/3keSg.png) !important;
  background-color: #21529f;
  background-size: 35px 35px;
  border-radius: 10%;
  width: 50px;
  height: 50px;
}

.leaflet-touch .leaflet-control-layers-toggle {
  background-image: url(https://i.stack.imgur.com/3keSg.png) !important;
  background-color: #21529f;
}

.leaflet-control-layers-expanded {
  /* height: 300px; */
  color: rgb(7, 6, 46);
  background-color: #ffffff;
}

.leaflet-top {
  display: inline-flex;
}

#Report {
  margin-left: 0 !important;
  z-index: 9;
}

#ShopsShow {
  z-index: 9;
}

#UsersShow {
  z-index: 9;
}

.text-topic {
  font-size: 14px;
  font-weight: bold;
  border-bottom: 2px solid #21529f;
  width: 50%;
}
.border-text {
  border: 1px solid #707070;
}

#resultSearchLocation {
  font-weight: lighter;
}

.leaflet-control {
  z-index: 9;
}

.p-dialog-footer {
  padding: 0px;
}
</style>

